/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M23 5a2 2 0 00-2-2H3a2 2 0 00-2 2v14a2 2 0 002 2h18a2 2 0 002-2V5z"
      />
      <path fill="currentColor" d="M7 10h2v9H7v-9zm4-5h2v14h-2V5zm4 8h2v6h-2v-6z" />
    </svg>
  );
});

IconComponent.displayName = 'IconMarketPulse24';

export const IconMarketPulse24: React.FC<ISVGIconProps> = createIcon(IconComponent);
